import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Information from 'views/management/usersVerification/information'; // Importing Information view

/**
 * UsersVerificationView class extends JetView to create a user verification interface.
 */
export default class UsersVerificationView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text translation
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component for the top of the view
                    elements: [
                        {
                            view: 'label', // Label for the toolbar
                            align: 'center', // Center alignment of the label
                            label: _('Verificar Cuenta'), // Localized label text
                        },
                        {
                            type: 'wide', // Wide button type
                            css: 'close-bottom', // CSS class for styling
                            cols: [
                                {
                                    view: 'icon', // Icon button for closing
                                    icon: 'wxi-close', // Icon type
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Icon width
                                    height: 30, // Icon height
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                Information, // Including the Information view
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            css: 'my-form-vc', // CSS class for styling the form
            rows: [left], // Rows configuration for the form
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object passed to the init function.
     */
    init(grid) {
        webix.ready(function () {
            webix.attachEvent('onRotate', function (orientation) {
                // Event listener for screen rotation
                window.location.reload(); // Reload the page on orientation change
            });
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $$(document).height() - this.scrollTop() - this.height(); // Returns the distance to the bottom
            };
        });
    }
}

// FILE DOCUMENTED
